import { LogUtils } from "./log-utils";

export interface ServerCsrfTokenResponse {
  token: string | null;
  cookies: string | null;
}

const getCsrfApiUrl = () => {
  const serviceDomain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;
  return serviceDomain ? `${serviceDomain}/api/v1/csrf` : "";
};

export async function fetchCsrfTokenServer(): Promise<ServerCsrfTokenResponse> {
  const csrfApiUrl = getCsrfApiUrl();
  if (!csrfApiUrl) {
    return { token: null, cookies: null };
  }

  try {
    const res = await fetch(csrfApiUrl, {
      credentials: "include",
      cache: "no-store",
    });

    if (!res.ok) {
      LogUtils.error(`Server CSRF token fetch failed: ${res.status}`);
      return { token: null, cookies: null };
    }

    const data = await res.json();
    const token = data?.data?._csrf ?? null;
    const cookieHeaders = res.headers.getSetCookie?.();
    const cookies = cookieHeaders?.join("; ") || null;
    return { token, cookies };
  } catch (error) {
    LogUtils.error("Server CSRF token fetch threw", error);
    return { token: null, cookies: null };
  }
}
